export const environment = {
  firebase: {
    apiKey: "AIzaSyCbEETnm0MgeCYAN1FeZp-qsz88ZrYLQMc",
    authDomain: "events.vs.staging.frc.nexus",
    databaseUrl: "https://nexus-vs-staging-default-rtdb.firebaseio.com",
    projectId: "nexus-vs-staging",
    storageBucket: "nexus-vs-staging.firebasestorage.app",
    messagingSenderId: "201869506558",
    appId: "1:201869506558:web:8faf195b4ea903cd2bf2af",
    measurementId: "G-QQBPP7ZS3R"
  },
  production: true,
  hostUrl: 'https://events.vs.staging.frc.nexus',
  mainHostUrl: 'https://vs.staging.frc.nexus',
  useEmulatedFunctions: false,
};
